export const taskManagerTrackingIDs = {
    taskManagerListItem: {
        id: 'dagligbank-task-manager',
    },
};
